export default {"src":"/_next/static/media/icon-laugh-unselect.40fb0217.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};